import React from "react";

function ExportArrowIcon(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.9L6 9.9L7.4 8.5L12 13.1L16.6 8.5L18 9.9L12 15.9Z"
        fill="#E8EAED"
      />
    </svg>
  );
}

export default ExportArrowIcon;
